import React from 'react';

const TermCondition = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 py-28 bg-white text-gray-800">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">
        Terms and Conditions
      </h1>

      <p className="mb-4">
        These general terms and conditions are part of the contract to which
        they are attached (the "Agreement") and apply to your use of any
        marketing or email data or services provided by{" "}
        <strong className="text-gray-800">Velonix Solution</strong> or its
        affiliated companies ("Velonix Solution"), which data or services are
        referred to collectively as the "Data."
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        1. Ownership
      </h2>
      <p className="mb-4">
        (a) "Velonix Solution Property" includes all systems, files, programs,
        interfaces, work products, and intellectual property used or developed
        by Velonix Solution in providing services to you, including websites and
        tools.
      </p>
      <p className="mb-4">
        (b) All Velonix Solution Property remains its exclusive property.
      </p>
      <p className="mb-4">
        (c) Velonix Solution owns all rights, titles, and interest in the Data
        and its intellectual property.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        2. Limited License
      </h2>
      <p className="mb-4">
        A nontransferable, nonexclusive license is granted upon agreement and
        payment, for direct marketing purposes for one year unless otherwise
        agreed. Upon termination, you must stop using and return or destroy the
        Data.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        3. Limitations on Use
      </h2>
      <p className="mb-4">
        (a) You will not share or resell the Data without written consent.{" "}
        <br />
        (b) Do not use Velonix Solution’s name in marketing materials. <br />
        (c) Do not use the Data for consumer credit, insurance, employment, or
        screening purposes covered by FCRA.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        4. Your Responsibilities
      </h2>
      <p className="mb-4">
        You are responsible for lawful use of the Data and agree to audits by
        Velonix Solution as needed.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        5. Disclaimer of Warranties
      </h2>
      <p className="mb-4">
        Data is provided "as-is". Velonix Solution disclaims all warranties. You
        have 14 days from receipt to report issues for correction at no extra
        cost.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        6. Limitation of Liability
      </h2>
      <p className="mb-4">
        Velonix Solution shall not be liable for indirect or consequential
        damages. Maximum liability is limited to the amount paid in the last 12
        months.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        7. Indemnification
      </h2>
      <p className="mb-4">
        You agree to indemnify and hold Velonix Solution and its personnel
        harmless from any claims related to your use of the Data.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        8. Interruption of Service
      </h2>
      <p className="mb-4">
        Temporary interruptions may occur and do not warrant refund or suspend
        your obligations.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        9. No Assignment
      </h2>
      <p className="mb-4">
        You may not assign rights under the Agreement without written consent.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        10. Termination
      </h2>
      <p className="mb-4">
        Velonix Solution may terminate the Agreement if terms are violated and
        request destruction or return of Data.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        11. Governing Law
      </h2>
      <p className="mb-4">
        Governed by laws of Nebraska, USA. Disputes shall be handled exclusively
        in Douglas County courts.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        12. Payment Terms
      </h2>
      <p className="mb-4">
        Fees are payable in advance and may recur. You authorize recurring
        charges unless canceled.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        13. Entire Agreement
      </h2>
      <p className="mb-4">
        This is the complete agreement and supersedes prior versions. Amendments
        must be in writing.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        14. File Management Library
      </h2>
      <p className="mb-4">
        You retain ownership of your uploaded marketing content. Infinitrix Data
        Stream provides storage but is not responsible for backups or
        unauthorized content.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-gray-800">
        15. Execution Counterparts
      </h2>
      <p className="mb-4">
        The Agreement may be signed electronically and in counterparts.
      </p>
    </div>
  );
};

export default TermCondition;
